// extracted by mini-css-extract-plugin
module.exports = {"b4bbze":"b4bbze","b1o93pze":"b1o93pze","b91guqy":"b91guqy","bez6j12":"bez6j12","image-description":"image-description"};